export { default } from "./AttachmentIcon";
